import React, { useEffect, useState } from "react";
import DeleteIcon from "../../assets/images/icons/deleteIcon";
import Button from "./DefaultButton";
import Input from "./InputComponent";
import { Height } from "@mui/icons-material";
import { ReactComponent as DownAngleBracket } from "../../assets/images/downAngleBracket.svg";
import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { options as optionsSelect } from "../Vendor/formConfig";
import CustomFields from "./CustomFields";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";

// const tableHeaderCategory = [
//   { label: "#", type: "serial", value: "serial", width: "5%", editable: false },
//   { label: "Category", type: "dropdown", value: "category", width: "35%", editable: true },
//   { label: "Description", type: "text", value: "description", width: "35%", editable: true },
//   { label: "Amount", type: "number", value: "amount", width: "20%", editable: true },
//   { label: "Action", type: "action_delete", value: "action", width: "5%", editable: false },
// ];

// const tableHeaderItemDetails = [
//   { label: "#", type: "serial", value: "serial", width: "5%", editable: false },
//   { label: "Product/Services", type: "dropdown", value: "category", width: "25%", editable: true },
//   { label: "Description", type: "text", value: "description", width: "25%", editable: true },
//   { label: "Quantity", type: "number", value: "quantity", width: "10%", editable: true },
//   { label: "Rate", type: "number", value: "rate", width: "10%", editable: true },
//   { label: "Amount", type: "number", value: "amount", width: "20%", editable: true },
//   { label: "Action", type: "action_delete", value: "action", width: "5%", editable: false },
// ];

const createRowFromHeaderConfig = (tableConfig) => {
  const rowData = tableConfig?.reduce((acc, EachHeader) => {
    acc[EachHeader.value] = "";
    return acc;
  }, {});
  console.log(rowData, "rowData");
  return rowData;
};
const TableComponent = ({ tableData, onChange, value, totalVoucherAmount, tableError, voucher }) => {
  const [openTable, setOpenTable] = useState(true);
  const [tableConfig, setTableConfig] = useState(tableData?.options?.headers || []);
  const tableHeader = tableData?.headers;
  const newRow = createRowFromHeaderConfig(tableConfig);
  const [rows, setRows] = useState([
    { ...createRowFromHeaderConfig(tableConfig), serial: 1 },
    { ...createRowFromHeaderConfig(tableConfig), serial: 2 },
  ]);

  const [editIndex, setEditIndex] = useState(null);
  const [touchedIndex, setTouchedIndex] = useState([]);
  const [isTabletouched, setIsTableTouched] = useState(false);
  // useEffect(() => {
  //   setTableConfig(tableData?.options?.headers);
  // }, []);

  useEffect(() => {
    const SubmitData = removeEmptyRows(rows);
    onChange({ target: { name: tableData?.id, value: SubmitData } });
  }, [rows]);

  useEffect(() => {
    setRows([
      { ...createRowFromHeaderConfig(tableConfig), serial: 1 },
      { ...createRowFromHeaderConfig(tableConfig), serial: 2 },
    ]);
    setEditIndex(null);
    setTouchedIndex([]);
  }, [voucher?.id]);

  const removeEmptyRows = (listData) => {
    return listData.filter((row) => {
      return !Object.keys(row)
        .filter((key) => !["serial", "action"].includes(key))
        .some((key) => row[key] === "" || row[key] === undefined);
    });
  };

  const addRow = (times) => {
    if (times === 1) {
      setRows([...rows, { ...newRow, serial: rows.length + 1 }]);
    } else {
      setRows([
        ...rows,
        { ...newRow, serial: rows.length + 1 },
        { ...newRow, serial: rows.length + 2 },
        { ...newRow, serial: rows.length + 3 },
        { ...newRow, serial: rows.length + 4 },
      ]);
    }
  };

  const deleteRow = (index) => {
    setRows(rows.filter((eachItem, i) => eachItem["serial"] !== index).map((row, i) => ({ ...row, serial: i + 1 })));
    setTouchedIndex((prev) => prev.filter((indexTouched, i) => indexTouched !== index));
  };

  const updateRow = (index, field, e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      setEditIndex(editIndex + 1);
      setTouchedIndex((prev) => [...prev, editIndex + 1]);
    } else {
      const updatedRows = [...rows];
      updatedRows[index - 1][field] = e?.target?.value;
      setRows(updatedRows);
    }
  };

  const getValueType = (type, inputValue, headerKey, index) => {
    switch (type) {
      case "action_delete":
        return (
          <button
            onClick={(e) => {
              e.stopPropagation();
              deleteRow(index);
            }}
            className="flex justify-center items-center h-full w-full min-w-[22px]"
          >
            <DeleteIcon color={"red"} size={22} />
          </button>
        );
      case "serial":
        return <div>{index}</div>;
      case "number":
        return <div className="h-[30px] p-1 text-right">{inputValue || "-"}</div>;
      default:
        return <div className="h-[30px] p-1 text-left">{inputValue || "-"}</div>;
    }
  };

  return (
    <div onBlur={() => setIsTableTouched(true)}>
      <h3 className="text-md font-medium mb-2 text-[#1d4469] font-semibold flex">
        {tableData?.header_name}
        <span className="mx-2">
          <button onClick={() => setOpenTable(!openTable)}>
            <DownAngleBracket className={`h-[10px]  text-1D4469 items-center ${!openTable ? "rotate-180" : ""}`} />
          </button>
        </span>
        {console.log(
          tableData?.isCompulsory,
          tableError,
          totalVoucherAmount === 0,
          "tableData?.isCompulsory && tableError && totalVoucherAmount === 0"
        )}
        {tableData?.isCompulsory && tableError && totalVoucherAmount === 0 && (
          <span
            className="flex gap-1 items-center text-xs text-gray-500 ms-1 text-[#BF2315] text-[10px]"
            role="alert"
            aria-live="assertive"
          >
            <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
            Please enter the {tableData?.header_name}
          </span>
        )}
      </h3>
      {openTable && (
        <div
          className={`overflow-x-auto border  ${tableData?.isCompulsory && tableError && totalVoucherAmount === 0 ? "border-[#BF2315]" : "border-gray-300"} bg-white rounded-md my-2`}
        >
          <table className="min-w-full  text-sm rounded-sm font-poppins table-fixed w-full">
            <thead className="bg-white text-[#1D4469] tracking-tighter rounded-t-lg border-b-2">
              <tr className="h-[47px]">
                {tableConfig?.map((item, i) => (
                  <th key={i} className={`relative px-4 py-2 font-400 text-center w-[${item.width}]`}>
                    {item.label}
                    {i !== tableConfig?.length - 1 && (
                      <div
                        className="absolute right-0 top-[15%] bottom-[15%] w-[1px] bg-gray-300"
                        aria-hidden="true"
                      ></div>
                    )}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows?.map((row, rowIndex) => (
                <tr
                  key={row["serial"]}
                  onClick={() => {
                    setEditIndex(row["serial"]);
                    setTouchedIndex((prevState) => [...prevState, row["serial"]]);
                    rowIndex === rows?.length - 1 && addRow(1);
                  }}
                  className={`cursor-pointer border border-b-1  h-[28px] hover:bg-gray-100`}
                >
                  {/* <td className=" px-4 py-1 text-center rounded-t-sm w-[5%] min-w-fit">{index + 1}</td> */}
                  {console.log(tableConfig, "tableConfig vishal")}
                  {tableConfig?.map((eachItem) => (
                    <td className=" px-4 py-1 w-[30%] text-center">
                      {/* {editIndex === index && eachItem.editable */}
                      {/* const CustomFields = ({ field, onChange, value, handleLinkClick }) =>  */}
                      {touchedIndex.includes(row["serial"]) ? (
                        // getValueType(eachItem.type, row[eachItem?.value], eachItem?.value, index)}
                        <>
                          {" "}
                          {console.log(row, "row[eachItem?.value]")}
                          <CustomFields
                            field={{ ...eachItem, id: eachItem?.value }}
                            onChange={(e) => updateRow(row["serial"], eachItem?.value, e)}
                            value={row[eachItem?.value]}
                            index={row["serial"]}
                            deleteRow={deleteRow}
                            isTable
                          />
                        </>
                      ) : (
                        getValueType(eachItem.type_name, row[eachItem?.value], eachItem?.value, row["serial"])
                      )}
                    </td>
                  ))}

                  {/* <td className=" py-1 text-center w-[10%] min-w-[22px]">
                
              </td> */}
                </tr>
              ))}
            </tbody>
          </table>
          <Button type="primary" onClick={() => addRow(4)} className="m-4 px-4 py-2  text-white rounded-md">
            Add Lines
          </Button>
        </div>
      )}
    </div>
  );
};

export default TableComponent;
